export default function Impressum() {
  return (
    <div data-testid="page-impressum" className="px-6 md:px-12 lg:px-24 pt-32 md:pt-40 pb-24">
      <div className="text-xs uppercase tracking-[0.3em] text-primary mb-6">Rechtliches</div>
      <h1 className="font-serif text-5xl sm:text-6xl font-light tracking-tighter mb-12">Impressum</h1>
      <div className="max-w-2xl space-y-8 text-foreground/90 leading-relaxed">
        <section>
          <h2 className="font-serif text-2xl mb-3">Angaben gemäß § 5 TMG</h2>
          <p>
            Keppel Immobilien<br />
            Inhaber: Jeremy Keppel<br />
            Kulmbacher Straße 74<br />
            95213 Münchberg
          </p>
        </section>
        <section>
          <h2 className="font-serif text-2xl mb-3">Kontakt</h2>
          <p>
            Telefon: 0221 – 64 00 90 81<br />
            E-Mail: post@keppel-immobilien.de
          </p>
        </section>
        <section>
          <h2 className="font-serif text-2xl mb-3">
            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
          </h2>
          <p>
            Jeremy Keppel<br />
            Kulmbacher Straße 74<br />
            95213 Münchberg
          </p>
        </section>
        <section>
          <h2 className="font-serif text-2xl mb-3">Haftungsausschluss</h2>
          <p className="text-sm text-muted-foreground">
            Die Inhalte dieser Seite wurden mit größtmöglicher Sorgfalt
            erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
            Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>
        </section>
      </div>
    </div>
  );
}
